<template>
  <form novalidate @submit.prevent="submit" v-if="attributeKey" class="entity-form">
    <v-progress-bar md-mode="indeterminate" v-if="isLoading" />
    <attribute-key-form-fields ref="attributeKeyFormFields" :attribute-key="attributeKey" @change="updateAttributeKeyObject" />

    <br />
    <div class="u-flex u-space-between">
      <v-button type="submit" :disabled="isLoading">Shrani</v-button>
      <v-button @click="goBack">Nazaj</v-button>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BackMixin from '@/components/shared/BackMixin'
import AttributeKeyFormFields from './AttributeKeyFormFields'
import VButton from 'design-system/VButton.vue'
import VProgressBar from 'design-system/VProgressBar.vue'

export default {
  components: {
    AttributeKeyFormFields,
    VButton,
    VProgressBar,
  },
  mixins: [BackMixin],
  computed: {
    ...mapState('accountStore/attributeKeys/forms', ['attributeKey']),
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions('accountStore/attributeKeys/forms', ['updateAttributeKeyObject']),
    submit () {
      this.runAllValidations()
      if (!this.isValid()) {
        return
      }

      this.$emit('submit')
    },
    runAllValidations () {
      this.$refs.attributeKeyFormFields.runAllValidations()
    },
    isValid () {
      return this.$refs.attributeKeyFormFields.isValid()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/common';
</style>
